import type { AuditEventQuery } from "../lib/url-state";

/**
 * Deterministic TanStack Query keys for the global audit ledger. `list`/
 * `detail` mirror the filtered-list + single-item shape in
 * promotion/api/query-keys.ts. React Query hashes key arrays by value (not
 * object identity), so two `AuditEventQuery` objects with the same fields
 * always resolve to the same cache entry regardless of property order.
 */
export const auditKeys = {
  all: ["audit-events"] as const,
  list: (query: AuditEventQuery) => [...auditKeys.all, "list", query] as const,
  detail: (eventId: number) => [...auditKeys.all, "detail", eventId] as const,
  exportJob: (jobId: string) => [...auditKeys.all, "export-job", jobId] as const,
};
